import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const ProductForm = ({ 
    product = null, 
    categories = [], 
    suppliers = [], 
    onSubmit, 
    onCancel, 
    loading = false 
}) => {
    const { t } = useTranslation(['inventory', 'common']);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        sku: '',
        barcode: '',
        category_id: '',
        supplier_id: '',
        unit_price: 0,
        cost_price: 0,
        quantity_in_stock: 0,
        minimum_stock_level: 0,
        maximum_stock_level: '',
        is_active: true
    });

    useEffect(() => {
        if (product) {
            setFormData({
                name: product.name || '',
                description: product.description || '',
                sku: product.sku || '',
                barcode: product.barcode || '',
                category_id: product.category_id || '',
                supplier_id: product.supplier_id || '',
                unit_price: product.unit_price || 0,
                cost_price: product.cost_price || 0,
                quantity_in_stock: product.quantity_in_stock || 0,
                minimum_stock_level: product.minimum_stock_level || 0,
                maximum_stock_level: product.maximum_stock_level || '',
                is_active: product.is_active !== false
            });
        }
    }, [product]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <form id="product-form" onSubmit={handleSubmit}>
            <div className="form-group">
                <label className="form-label">{t('inventory:name')} *</label>
                <input
                    type="text"
                    className="form-input"
                    value={formData.name}
                    onChange={(e) => handleChange('name', e.target.value)}
                    required
                />
            </div>

            <div className="form-group">
                <label className="form-label">{t('inventory:sku')} *</label>
                <input
                    type="text"
                    className="form-input"
                    value={formData.sku}
                    onChange={(e) => handleChange('sku', e.target.value)}
                    required
                />
            </div>

            <div className="form-group">
                <label className="form-label">{t('inventory:category')}</label>
                <select
                    className="form-input"
                    value={formData.category_id}
                    onChange={(e) => handleChange('category_id', e.target.value)}
                >
                    <option value="">{t('common:select')}</option>
                    {categories.map(cat => (
                        <option key={cat.id} value={cat.id}>{cat.name}</option>
                    ))}
                </select>
            </div>

            <div className="form-group">
                <label className="form-label">{t('inventory:supplier')}</label>
                <select
                    className="form-input"
                    value={formData.supplier_id}
                    onChange={(e) => handleChange('supplier_id', e.target.value)}
                >
                    <option value="">{t('common:select')}</option>
                    {suppliers.map(sup => (
                        <option key={sup.id} value={sup.id}>{sup.name}</option>
                    ))}
                </select>
            </div>

            <div className="form-row">
                <div className="form-group">
                    <label className="form-label">{t('inventory:unitPrice')} *</label>
                    <input
                        type="number"
                        className="form-input"
                        step="0.01"
                        value={formData.unit_price}
                        onChange={(e) => handleChange('unit_price', parseFloat(e.target.value))}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="form-label">{t('inventory:costPrice')} *</label>
                    <input
                        type="number"
                        className="form-input"
                        step="0.01"
                        value={formData.cost_price}
                        onChange={(e) => handleChange('cost_price', parseFloat(e.target.value))}
                        required
                    />
                </div>
            </div>

            <div className="form-row">
                <div className="form-group">
                    <label className="form-label">{t('inventory:quantity')} *</label>
                    <input
                        type="number"
                        className="form-input"
                        value={formData.quantity_in_stock}
                        onChange={(e) => handleChange('quantity_in_stock', parseInt(e.target.value))}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="form-label">{t('inventory:minStock')}</label>
                    <input
                        type="number"
                        className="form-input"
                        value={formData.minimum_stock_level}
                        onChange={(e) => handleChange('minimum_stock_level', parseInt(e.target.value))}
                    />
                </div>
            </div>

            <div className="form-group">
                <label className="form-label">{t('inventory:description')}</label>
                <textarea
                    className="form-input"
                    value={formData.description}
                    onChange={(e) => handleChange('description', e.target.value)}
                />
            </div>

            <div className="form-group">
                <label className="form-checkbox">
                    <input
                        type="checkbox"
                        checked={formData.is_active}
                        onChange={(e) => handleChange('is_active', e.target.checked)}
                    />
                    {t('inventory:active')}
                </label>
            </div>

        </form>
    );
};

export default ProductForm;